import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { RouterProvider } from 'react-router-dom'
import { I18nProvider } from '@/i18n/i18n'
import { ThemeProvider } from '@/providers/theme-provider'
import { Splash } from '@/components/splash'
import { router } from '@/router'
import { initializeAnalytics } from '@/lib/analytics'
import '@/styles.css'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false }, mutations: { retry: 0 } },
})

initializeAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider><I18nProvider><RouterProvider router={router} /><Toaster richColors position="top-center" /><Splash /></I18nProvider></ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
